<template>
  <div v-show="show" :class="show ? 'enable' : 'disabled'">
    <!-- 通用领取开始-->
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <p class="actModules_descripe line" v-html="modulesRules"></p>
      <div class="actSlider">
        <!-- <div class='actSlider_tab_h' :class="'actSlider_tab-' + tabSize">
					<a
						href='javascript:;'
						class='actSlider_tabItems_h'
						:class="{'active':activeIndex == index}"
						v-for="(tabItem,index) in tabItems"
						:key="index"
						@click="tabSlider(index), activeIndex=index"
					>{{tabItems[index].tabText}}</a>
				</div> -->
        <div class="actSlider_content_h">
          <div v-for="(tabItem, index) in tabItems" :key="index">
            <div class="actSlider_contentItems_h">
              <img :src="tabItems[index].image.value" />
              <!-- <img v-if="tabItems[activeIndex].image" :src="tabItems[activeIndex].image"> -->
            </div>
            <template>
              <div class="actModules_btnWrap">
                <template v-if="!!h5Geted[index]">
                  <a
                    href="javascript:;"
                    class="disabled actModules_btn_h"
                    v-text="tabItem.buttonName"
                  ></a>
                </template>
                <template v-else>
                  <a
                    href="javascript:;"
                    @click="open"
                    class="actModules_btn_h"
                    v-text="tabItem.buttonName"
                  ></a>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-show="popup" class='popup'>
      <div class="head">
        <div class="title">领取帐号</div>
        <div @click="close" class="actModal_closeBtn">关闭</div>
      </div>
       <input type="text" v-model="accounts" class="actModal_text" />
       <div @click="submit" class="actModal_footerBtn">立即领取</div>
    </div>
    <!-- 通用领取结束-->
    <div v-show="giftpopup" class="gift">
      <div class='loading'/>
      <div class='giftmain'>
        <div class="head">
          <img :src="giftimg" />
        </div>
        <div class="title">恭喜你获得了{{gitftname}}</div>
        <div @click="giftClose" class="actModal_footerBtn">立即领取</div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/css/reset.css';
import bus from '../../../bus';
import { mixins } from '../../../src/h5mixins';
import 'swiper/dist/css/swiper.css';
import { buryingPoint } from '../buryingPoint/receive';
export default {
	name: 'h5-seven-horizontal-one',
	mixins: mixins,
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			gamePkgName: '超核渠道游戏包名',
			modulesRules: '规则描述',
			tabItems: '选项',
			name: '名称',
			image: '图片',
			media: '媒体',
			action: 'app动作',
			h5Action: 'h5动作',
			tabText: 'Tab文案',
			buttonName: '按钮文案',
			showtype: '展示(1安卓,0 IOS)',
			showPopup: '是否展示弹窗(1是，空否)',
			whiteList: '白名单展示',
			giftShow: '是否展示礼包弹窗(1是，空否)'
		}
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字'
		},
		gamePkgName: {
			type: String,
			default: ''
		},
		modulesRules: {
			type: String,
			default:
        '活动规则：规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案'
		},
		tabItems: {
			type: Array,
			default () {
				return [
					{
						tabText: '1',
						image: {
							class: 'image',
							value: ''
						},
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						h5Action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
							ruleId: ''
						},
						buttonName: ''
					}
				];
			}
		},
		showtype: {
			type: String,
			default: '1' // 展示判断：1安卓，0IOS
		},
		showPopup: {
			type: String,
			default: ''
		},
		whiteList: {
			type: Array,
			default: function () {
				return [{
					action: {
						class: 'action',
						title: '白名单展示查询',
						value: ''
					}}
				];
			}
		},
		giftShow: {
			type: String,
			default: ''
		},
	},
	data () {
		return {
			activeIndex: 0,
			tabSize: 1,
			geted: [false],
			h5Geted: [false],
			show: true,
			popup: false,
			accounts: '',
			giftpopup: false,
			gitftname: '',
			giftimg: ''
		};
	},
	computed: {},
	updated () {
		this.initPlayer(this.activeIndex);
	},
	mounted () {
		if (this.$actMode !== 'production') {
			return;
		}
		bus.$on('showtype', val => {
			this.show = val == this.showtype;
		});
		bus.$on('showNamelist', val => {
			this.showMode();
		});
		bus.$on('giftReceivedStatus', isGetedh5 => {
			console.log(isGetedh5);
			if (typeof isGetedh5 === 'undefined') {
				return;
			}
			for (let i = 0; i < this.tabItems.length; i++) {
				let idx = this.tabItems[i].h5Action.ruleId;
				if (typeof isGetedh5['h' + idx] !== 'undefined') {
					if (isGetedh5['h' + idx][0] > 0 && isGetedh5['h' + idx][1] === '0') {
						this.$set(this.h5Geted, i, true);
					} else {
						this.h5Geted[i] = false;
					}
				} else {
					this.h5Geted[i] = false;
				}
			}
			console.log(this.h5Geted);
		});
	},
	methods: {
		doAction () {
			if (this.$actMode !== 'production') {
				return;
			}
			const itemConf = this.tabItems[this.activeIndex];
			if (itemConf.h5Action.type === 'received') {
				this.receiveGift(itemConf.h5Action.type, itemConf.h5Action.value);
			} else if (itemConf.h5Action.type === 'gotoApp') {
				this.$gotoApp(itemConf.h5Action.value);
			} else if (itemConf.h5Action.type === 'link') {
				window.location.href = itemConf.h5Action.value;
			}
		},
		tabSlider (index) {
			this.initPlayer(index);
		},
		initPlayer (index) {
			/* const { md } = this.tabItems[index];
			const fontSize = parseFloat(document.getElementsByTagName('html')[0].style.fontSize.match(/\d+/g)[0])
			if (!md) return;
			this.player = new window.Txplayer({
				// 点播容器dom的ID
				containerId: `v-container-${index}`,
				vid: md.value,
				width: 6.9 * fontSize,
				height: 3 * fontSize,
				listener: (msg) => console.log('listener', msg),
				// poster: 'http://ossweb-img.qq.com/upload/adw/image/201808/1535305458002150094.jpg'
			}) */
		},
		receiveGift (actionType, actionValue) {
			this.$doAction(actionType, actionValue, {sqq: this.accounts})
				.then(({ sPackageName, iPackageId }) => {
					if (sPackageName) {
						if (this.giftShow) {
							this.gitftname = sPackageName;
							this.giftimg = `https://game.gtimg.cn/images/tgclub/giftimg/${this.$actConfig.actId}/${iPackageId}.png`;
							this.giftpopup = true;
						} else {
							alert(`恭喜你获得了${sPackageName}，请查收`);
							this.$set(this.h5Geted, this.activeIndex, true);
							buryingPoint(this.modulesTitle, this.$axios);
						}
					}
				})
				.catch(e => {
					console.log(e);
					alert(e.sMsg);
				});
			this.close();
		},
		close () {
			this.popup = false;
		},
		giftClose () {
			this.giftpopup = false;
			bus.$emit('isLogined');
		},
		open () {
			if (this.showPopup) {
				this.popup = true;
			} else {
				this.doAction();
			}
		},
		submit () {
			if (/^[1-9]\d{4,10}$/.test(this.accounts)) {
				this.doAction();
			} else {
				alert('请输入正确QQ帐号');
			}
		},
		async showMode () {
			try {
				const [{action: { value }}] = this.whiteList;
				if (value) {
					const {res: { sOutValue1 }} = await this.$doAction('ame', value, {sServiceType: this.$actConfig.gameCode});
					if (sOutValue1 == '1') {
						this.show = true;
					} else {
						this.show = false;
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
	}
};
</script>

<style>
@import "../../assets/css/reset.css";
@import "swiper/dist/css/swiper.css";
</style>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
//引入 scss 模块组件
@import "../../assets/scss/common";

.actSlider {
  width: 7.3rem;
  margin: 0.1rem auto 0;
  background: #d8d8d8;

  &.vertical {
    @extend %clearfix;

    &.five {
      .actSlider_tab_h {
        padding: 0.2rem 0;
      }
    }

    .actSlider_tab_h {
      @extend %left;
      width: 1.5rem;
      padding: 0.4rem 0;
    }

    .actSlider_content_h {
      @extend %left;
      width: 5.8rem;
      padding: 0.4rem 0.2rem;
    }

    .actSlider_tabItems_h {
      width: 1.46rem;
    }
  }

  &.one {
    height: 3.8rem;
  }

  img {
    width: 100%;
  }
}

.actSlider_tab_h {
  @extend %clearfix;

  &.actSlider_tab-7 {
    .actSlider_tabItems_h {
      width: 14.285%;
    }
  }

  &.actSlider_tab-6 {
    .actSlider_tabItems_h {
      width: 16.66666%;
    }
  }

  &.actSlider_tab-5 {
    .actSlider_tabItems_h {
      width: 20%;
    }
  }

  &.actSlider_tab-4 {
    .actSlider_tabItems_h {
      width: 25%;
    }
  }

  &.actSlider_tab-3 {
    .actSlider_tabItems_h {
      width: 33.33333%;
    }
  }

  &.actSlider_tab-2 {
    .actSlider_tabItems_h {
      width: 50%;
    }
  }

  &.actSlider_tab-1 {
    .actSlider_tabItems_h {
      width: 100%;
    }
  }
}

.actSlider_tabItems_h {
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.24rem;
  text-align: center;
  background: #a4a4a4;
  color: #4a4a4a;
  @extend %block;
  @extend %left;
  border: 1px solid #666666;

  &.active {
    background: #d8d8d8;
  }
}

.actSlider_contentItems_h {
  width: 6.9rem;
  height: 3rem;

  img {
    width: 100%;
    height: 100%;
  }

  .vertical & {
    width: 5.4rem;
    height: 3rem;
  }
}

.actSlider_content_h {
  width: 7.3rem;
  padding: 0.2rem;
}
.disabled {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/receive-h/x-seven-horizontal-one.vue